<template>
    <div>
        <Layout>
            <div v-if="!isLoading" class="col-lg-12">
                <div class="card mb-0">
                    <div class="card-body" style="min-height: 100vh">
                        <b-tabs
                            v-model="modelTab"
                            vertical
                            justified
                            nav-class="nav-tabs-custom cus-document"
                            active-nav-item-class="font-weight-bold "
                            content-class="p-3 text-muted"
                        >
                            <b-tab v-for="(tab, index) in TABS" :key="index" class="border-0" :disabled="tab.disabled">
                                <template v-slot:title>
                                    <span class="">{{ tab.name }}</span>
                                </template>
                                <div>
                                    <SettingBasic
                                        v-if="tab.id === 1"
                                        :dataForm.sync="formData"
                                        :configForm="configFormBasic"
                                        :listPage="PAGE_TYPE_FIXED"
                                        :templatePage="temporarilyList"
                                        :configValidFormLottery="formLotteryConfig"
                                        @handleOpenSelectTemplate="openSelectTemplate"
                                        @selectPage="handleSelectPage"
                                    />
                                    <SettingDesign v-else-if="tab.id === 2" :dataForm.sync="formData" />
                                    <SettingPage
                                        v-else-if="tab.id === 3"
                                        :dataForm.sync="formData"
                                        :listPage="PAGE_TYPE_FIXED"
                                        :configForm="configFormPage"
                                    />
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
                <Footer>
                    <div class="d-flex justify-content-center">
                        <div class="text-center flex-fill">
                            <button type="submit" @click="handleCancel" class="btn btn-common-footer mr-3">{{ $t('btn.cancel') }}</button>
                            <button type="submit" @click="handleSubmit" class="btn btn-common btn-primary">
                                <i class="ri-file-add-line"></i>{{ $t('btn.register') }}
                            </button>
                        </div>
                    </div>
                </Footer>
            </div>
            <div class="d-flex justify-content-center" v-else>
                <LoadingIcon />
            </div>
        </Layout>
    </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import Footer from '@/components/Footer/main.vue';
import SettingBasic from '../components/setting-basic/main.vue';
import SettingDesign from '../components/setting-design/main.vue';
import SettingPage from '../components/setting-page/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';

import { TABS, PAGE_TYPE_FIXED, initForm, onHandleTabForm, ID_PAGE_TYPE } from '../constants';
import { configFormBasic } from '../components/setting-basic/constants';
import { configFormPage } from '../components/setting-page/constants';
import { validateAllField } from '@/utils/validate';
import { handleDataBeforeSendServer, handleAlertValidateTabs, onHandleGetListTemporarily } from '../handlers';
import { managerFormMethods } from '@/state/helpers';
import { showMessage } from '@/utils/messages';
import { handleValidSettingLottery, configFormLottery } from '@/views/pages/phase2/manager-form/components/setting-lottery/constants';
import { checkPermission, onScrollToFieldError } from '@/utils/handlers';

export default {
    name: 'ManagerFormCreate',
    page: {
        title: 'キャンペーン一覧',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout,
        Footer,
        SettingBasic,
        SettingDesign,
        SettingPage,
        LoadingIcon
    },
    beforeRouteEnter(to, from, next) {
        if (!checkPermission('form.register')) {
            next({ name: 'errorPage' });
        }
        next();
    },
    data() {
        return {
            TABS: TABS()
                .map((tab) => {
                    if (tab.id == 1) {
                        tab.disabled = false;
                    } else {
                        tab.disabled = true;
                    }
                    return tab;
                })
                .filter((tab) => ![4, 5, 6, 7, 8].includes(tab.id)),
            formData: initForm(),
            configFormBasic: configFormBasic(),
            configFormPage: configFormPage(),
            formLotteryConfig: configFormLottery(),
            PAGE_TYPE_FIXED: PAGE_TYPE_FIXED,
            isLoading: false,
            modelTab: 0,
            temporarilyList: []
        };
    },
    watch: {
        modelTab() {
            this.$nextTick(() => {
                onScrollToFieldError();
            });
        }
    },
    methods: {
        ...managerFormMethods,

        handleCancel() {
            this.$router.push({
                path: '/manager-form/list'
            });
        },

        async handleSubmit() {
            let validateResult = handleAlertValidateTabs(
                {
                    checkFormBasic: validateAllField(this.configFormBasic),
                    checkStarPublichWithEndPublic: true, //validateEndDate(this.configFormBasic['configFieldPublicationStartDateTime'],this.configFormBasic['configFieldPublicationEndDateTime'])
                    checkSettingDesign: true,
                    checkFormPage: true, //validateAllField(this.configFormPage),
                    checkTabSettingMail: true,
                    checkTabSettingLottery:
                        this.formData?.page_type?.id === ID_PAGE_TYPE.B
                            ? handleValidSettingLottery(this.formData.setting_lottery, this.formLotteryConfig)
                            : true,
                    checkTabSettingCalendar: true
                },
                this.$bvToast,
                this.modelTab,
                this.TABS
            );
            if (!validateResult.check) {
                this.$nextTick(() => {
                    onScrollToFieldError();
                });
                return;
            }
            let payload = handleDataBeforeSendServer(this.formData);
            this.isLoading = true;
            try {
                const data = await this.registerManagerForm(payload);
                if (data.code !== 200) {
                    showMessage(data.code, this.$bvToast, this.$t(data.message));
                    return;
                }
                this.$router.push({ path: '/manager-form/list' }).then(() => {
                    showMessage(data.code, this.$bvToast, 'フォームが作成されました。');
                });
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoading = false;
            }
        },

        openSelectTemplate() {
            onHandleGetListTemporarily(this);
        },

        handleSelectPage(page) {
            this.TABS = onHandleTabForm(page?.id).map((tab) => {
                if (tab.id == 1) {
                    tab.disabled = false;
                } else {
                    tab.disabled = true;
                }
                return tab;
            });
        }
    }
};
</script>

<style lang="scss"></style>
